import { MenuItem, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";


const MBSSuccessSelect = (props) => {
    const { t } = useTranslation();
    return <TextField {...props} label={t('MBS_SUCCESS_SELECT')} select>
        <MenuItem value={""}>{t("ALL")}</MenuItem>
        <MenuItem value={"true"}>{t("MBS_CALL_SUCCESS")}</MenuItem>
        <MenuItem value={"false"}>{t("MBS_CALL_ERROR")}</MenuItem>
    </TextField>;
}

export default MBSSuccessSelect;
